import { warn } from '@swivl-mono/helpers';
import { create } from 'zustand';
import { Member } from '../Member/Member.Current';
import { RoleInterface, RoleInterfaceMap } from '@swivl-mono/types';
import { AlertsModel } from '../Notifications/Alerts.Model';
import { API } from '@swivl-mono/api-helper';

interface StoreInterface {
  parentRoles?: RoleInterfaceMap;
  roles?: RoleInterfaceMap;
  rolesLoaded?: boolean;
}

const BlankState: StoreInterface = {
  roles: undefined,
  parentRoles: undefined,
  rolesLoaded: false

  // rolesMap:undefined
};

export default class RolesModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = RolesModel.useState.setState;
  static get state() {
    return RolesModel.useState.getState();
  }
  static reset() {
    RolesModel.setState({ ...BlankState });
  }

  static loadRoles(orgIdToLoad?: number) {
    
    if (!orgIdToLoad && !Member.orgId) {
      warn('Cannot load roles without orgId', Member.orgId, orgIdToLoad);
      return;
    }
    const orgId = orgIdToLoad || Member.orgId;
    if (!orgId) { warn("No org id"); return;  }
    return API.Roles.loadRoles(orgId)
    .then(
      (data: { parentRoles: RoleInterfaceMap; roles: RoleInterfaceMap }) => {
      
        
        RolesModel.setState({
          roles: data.roles,
          parentRoles: data.parentRoles,

          rolesLoaded: true
        });
      }
    );
  }

  static mergedActionsForRole(role: RoleInterface) {
    if (role.parentSlug && RolesModel.state.parentRoles) {
      const parent = RolesModel.state.parentRoles[role.parentSlug];
      if (parent) {
        return { ...parent.actions, ...role.actions };
      }
    }
    return role.actions;
  }

  static updateRole(role: Partial<RoleInterface>) {
    if (!role.id || !role.slug) {
      warn('Cannot update role without id');
      return;
    }
    let roles = RolesModel.state.roles;
    if (!roles) {
      warn('Cannot update role without roles');
      return;
    }

    roles[role.slug] = { ...roles[role.slug], ...role };
    RolesModel.setState({ roles });

    API.Roles.updateRole(Member.orgId!, role.id, role)
      .then((role: RoleInterface) => {
        
      })
      .catch((error) => {
        
        RolesModel.loadRoles();
        AlertsModel.errorToast('Error updating role');
      });
  }

  static createRole(name:string, parentSlug?:string) {

    

    API.Roles.createRole(Member.orgId, name, parentSlug)
      .then((role: RoleInterface) => {
        
        RolesModel.loadRoles();
      })
      .catch((error) => {
        
        RolesModel.loadRoles();
        AlertsModel.errorToast('Error creating role');
      });
  }
  static deleteRole(roleId: number) {
    if (!roleId) {
      warn('Cannot delete role without id');
      return;
    }
    return API.Roles.deleteRole(Member.orgId!, roleId)
      .then((_) => {
        
        return RolesModel.loadRoles();
      })
      .catch((error) => {
        
        RolesModel.loadRoles();
        AlertsModel.errorToast('Error deleting role');
      });
  }
}
